import React, { PureComponent } from "react";
import { NavLink, withRouter } from "react-router-dom";
import axios from "axios";

import ApiGeneral from "../../../../generalApi";

const apiGeneral = new ApiGeneral();

class Success extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sessionId: "",
      loading: true,
    };
    this.getUrlVars = this.getUrlVars.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  getUrlVars(url) {
    var vars = {};
    var parts = url.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  }

  componentDidMount() {
    //var where = this.props.location.search;
    //var param = where.substr(where.indexOf("=") + 1);

    var params = this.getUrlVars(this.props.location.search);

    var sessionId = params["session_id"];
    var username = decodeURIComponent(params["username"]);
    var password = params["password"];

    this.setState({ sessionId: param, loading: true });

    //console.log("PARAM", param);

    axios
      .post(
        `${apiGeneral.getApiUrl()}/stripe/getpaymentsession`,
        {
          sessionId: sessionId,
          testing: apiGeneral.testing(),
          email: username,
        },
        { crossDomain: true }
      )
      .then((res) => {
        //console.log(res);
        //console.log(res.data);

        this.setState({ loading: false });

        window.location.replace("/#/app/videos/cursos");
      })
      .catch((err) => {
        //console.log(err);
      });
  }

  getContent() {
    if (this.state.loading) {
      return (
        <div className="page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-content">
            <div className="error-code mb-4 animated zoomInDown">
              <img src="assets/images/Target-128.png" />
            </div>
            <h2 className="text-center fw-regular title animated bounceIn animation-delay-10">
              Cargando...
            </h2>

            <p className="text-center animated flipInX animation-delay-20"></p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-content">
            <div className="error-code mb-4 animated zoomInDown">
              <img src="assets/images/Thumbs-Up-128.png" />
            </div>
            <h2 className="text-center fw-regular title animated bounceIn animation-delay-10">
              Pago realizado correctamente
            </h2>

            <p className="text-center animated flipInX animation-delay-20"></p>
          </div>
        </div>
      );
    }
  }

  render() {
    return <div>{this.getContent()}</div>;
  }
}

export default Success;



// WEBPACK FOOTER //
// ./app/routes/extraPages/routes/success/index.js